<template>
    <g>
        <path :style="{ fill: color }" d="M56.5,63.9c0.4,0.3-1.2,0-2.6,0c-1.4,0-2.8,0.2-2.6,0c0.3-0.2,1.2-0.7,2.6-0.7
		C55.3,63.3,56.2,63.7,56.5,63.9z"/>
        <path :style="{ fill: color }" d="M59,60.6c-0.6,0-2.1-0.7-3.1-0.7c-1,0-1.9,0.3-2,0.4c-0.1-0.1-1.2-0.4-2.1-0.4c-1,0-2.4,0.7-3,0.7
		c-0.6,0-0.8-0.2-0.8-0.2s0,0.3,0.1,0.4c0.6,0.4,1.7-0.1,3,0c1.1,0,1.9,0.3,2.9,0.4c0,0,0.1,0,0.1,0c1-0.1,1.7-0.3,2.9-0.4
		c1.3,0,2.4,0.4,3,0c0.1-0.1,0.1-0.4,0.1-0.4S59.6,60.7,59,60.6z"/>
    </g>
</template>

<script>
    import Mouth from './Mouth';

    export default {
        name: 'Mouth4',
        mixins: [Mouth],
    }
</script>
